export const BadgeRankingIcon = ({
  width = '30',
  height = '38',
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 38"
      fill="none"
      className={className}
    >
      <path
        opacity="0.5"
        d="M16.4902 0.640961H12.7402C9.2047 0.640961 7.43693 0.640961 6.33859 1.73932C5.24023 2.83765 5.24023 4.60542 5.24023 8.14096V11.891V14.7035H23.9902V11.891V8.14096C23.9902 4.60542 23.9902 2.83765 22.8918 1.73932C21.7934 0.640961 20.0257 0.640961 16.4902 0.640961Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.307 7.7343C15.6285 6.819 13.5999 6.819 11.9212 7.7343L2.93214 12.6359C1.12466 13.6214 0 15.5157 0 17.5745V26.8325C0 28.8912 1.12466 30.7855 2.93214 31.771L11.9212 36.6727C13.5999 37.5878 15.6285 37.5878 17.307 36.6727L26.2961 31.771C28.1036 30.7855 29.2284 28.8912 29.2284 26.8325V17.5745C29.2284 15.5157 28.1036 13.6214 26.2961 12.6359L17.307 7.7343ZM14.6145 16.5785C14.082 16.5785 13.7258 17.2175 13.0133 18.4957L12.8289 18.8264C12.6264 19.1896 12.5252 19.3711 12.3673 19.4909C12.2094 19.6107 12.0129 19.6553 11.6198 19.7442L11.2618 19.8252C9.87823 20.1383 9.18645 20.2947 9.02186 20.824C8.85727 21.3533 9.32889 21.9048 10.2721 23.0078L10.5161 23.2932C10.7842 23.6065 10.9182 23.7633 10.9785 23.9572C11.0388 24.151 11.0185 24.3601 10.978 24.7784L10.9411 25.159C10.7985 26.6307 10.7272 27.3665 11.1581 27.6937C11.589 28.0207 12.2366 27.7225 13.5321 27.1261L13.8673 26.9718C14.2354 26.8023 14.4195 26.7175 14.6145 26.7175C14.8097 26.7175 14.9938 26.8023 15.3619 26.9718L15.6969 27.1261C16.9924 27.7225 17.6402 28.0207 18.0711 27.6937C18.5019 27.3665 18.4307 26.6307 18.288 25.159L18.2511 24.7784C18.2106 24.3601 18.1903 24.151 18.2507 23.9572C18.3109 23.7633 18.4449 23.6065 18.7129 23.2932L18.957 23.0078C19.9003 21.9048 20.3719 21.3533 20.2072 20.824C20.0426 20.2947 19.3509 20.1383 17.9674 19.8252L17.6094 19.7442C17.2163 19.6553 17.0196 19.6107 16.8619 19.4909C16.704 19.3711 16.6028 19.1896 16.4003 18.8264L16.2159 18.4957C15.5034 17.2175 15.1472 16.5785 14.6145 16.5785Z"
        fill="currentColor"
      />
    </svg>
  );
};
